import { useEffect, useState } from "react";
import {
	type AdminAccess,
	loadAdminAccess,
	NO_ADMIN_ACCESS,
} from "@/utils/admin-access";

/**
 * Izin panel admin untuk komponen. Sebelum jawaban server tiba nilainya
 * "tanpa akses" (fail-closed), jadi sidebar menampilkan menu bergating hanya
 * setelah izinnya diketahui — bukan menampilkan dulu lalu menghilang.
 */
export function useAdminAccess(): { access: AdminAccess; loaded: boolean } {
	const [access, setAccess] = useState<AdminAccess>(NO_ADMIN_ACCESS);
	const [loaded, setLoaded] = useState(false);

	useEffect(() => {
		let active = true;
		loadAdminAccess().then((value) => {
			if (!active) return;
			setAccess(value);
			setLoaded(true);
		});
		return () => {
			active = false;
		};
	}, []);

	return { access, loaded };
}
